import React from 'react'
import { Grid } from '@material-ui/core'

import Utils from '@utils'
import Input from '@components/Input'

const FormGroup = props => {
  const { formik } = props
  const { handleBlur, handleChange, values, errors } = formik

  return (
    <Grid item xs className="mg-auto">
      <Grid item xs={12} sm={12}>
        <Input
          {...props}
          name="summary"
          onBlur={handleBlur}
          onChange={handleChange}
          label="HOME_ADD_EDIT_INPUT_LABEL_SUMMARY"
          value={Utils.getValue(values, 'summary')}
          error={Utils.getValue(errors, 'summary')}
          helperText={Utils.getValue(errors, 'summary')}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Input
          {...props}
          name="text"
          type="ckeditor"
          onBlur={handleBlur}
          onChange={handleChange}
          label="HOME_ADD_EDIT_INPUT_LABEL_TEXT"
          value={Utils.getValue(values, 'text')}
          error={Utils.getValue(errors, 'text')}
          helperText={Utils.getValue(errors, 'text')}
        />
      </Grid>
    </Grid>
  )
}

export default FormGroup
